"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var applyBulkItemActionOperation_1 = require("owa-service/lib/operation/applyBulkItemActionOperation");
var Utils_1 = require("owa-service/lib/Utils");
/**
 * Always move to Focused or Other Service
 * @param sourceFolderId the source folderId
 * @param emailAddresses emailaddresses
 * @param itemPropertytoUpdate the item property to update
 * @return the ApplyBulkItemActionResponse
 */
function alwaysMoveToFocusedOtherService(sourceFolderId, emailAddresses, itemPropertytoUpdate) {
    var requestBody = {
        SourceFolderId: sourceFolderId,
        EmailAddresses: emailAddresses,
        ActionType: 3 /* MoveToFocusedOther */,
        ItemPropertyToUpdate: itemPropertytoUpdate,
    };
    return applyBulkItemActionOperation_1.default({
        Header: Utils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body;
    });
}
exports.alwaysMoveToFocusedOtherService = alwaysMoveToFocusedOtherService;
//# sourceMappingURL=alwaysMoveToFocusedOtherService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/services/alwaysMoveToFocusedOtherService.js
// module id = 5629
// module chunks = 62